module.exports = __webpack_public_path__ + "img/logo 8.83bd0df.png";